import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';
import {ButtonDirective} from 'primeng/button';

@Component({
  selector: 'app-landing-list',
  standalone: true,
  imports: [
    RouterLink,
    ButtonDirective
  ],
  templateUrl: './landing-list.component.html',
  styleUrl: './landing-list.component.scss'
})
export class LandingListComponent {

}
